<template>
  <div class="col-lg-12 col-md-12" v-if="$store.state.workflowStore.workflowsS[actionCount].type != 'trigger'">
  <div class="col-lg-12 col-md-12">
    <!--      v-for="(action, i) in workflowStore.workflowsS"-->
    <!--      :key="i"-->
    <div class="workflow-group">
      <!--        v-if="action.type == 'action'"-->
      <ul class="list-group" :id="'editorForm' + actionCount">
        <li
          class="list-group-item workflow-green"
          @click="showForm(actionCount)"
        >
          <strong>{{ actionCount + 1 }}. 액션</strong>
          <strong id="removeWorkBtn" v-if="actionCount > 1" @click="removeAction(actionCount)"
            >x</strong
          >
        </li>
        <div class="card workflow-content" v-show="formIndex == actionCount">
          <div
            class="header"
            v-if="selectedApp == null"
          >
            액션은 워크플로우가 시작된 후 수행하는 이벤트입니다.
          </div>

          <div class="body">
            <div
              class="input-group search"
              v-if="selectedApp == null"
            >
              <input
                type="text"
                class="form-control"
                placeholder="검색하기..."
                v-model="keyword"
              />
              <div class="input-group-append">
                <span class="input-group-text" @click="totalApps()"
                  ><font-awesome-icon :icon="faSearch"
                /></span>
              </div>
            </div>
            <div
              v-if="selectedApp == null"
              id="appListContainer"
              class="container row clearfix row-deck"
            >
              <div
                class="btn btn-neutral apps col-lg-3 col-md-6 col-sm-12 card"
                v-for="(app, index) in totalAppList"
                :key="app.id"
                @click="chooseApp(actionCount, index)"
              >
<!--                <strong><img class="workIcon" :src="getImagePath(app.appImage)" />{{app.appName}}</strong>-->
<!--                <strong><img class="workIcon" :src="getImagePath(app.appImage)" />{{app.appName}}</strong>-->
                  <strong v-if="app.appCode === 'APPS20220712133352482'"><img class="workIcon" src="@/assets/images/finallogo.png" />{{ app.appName }}</strong>
                  <strong v-else-if="app.appCode === 'APPS20240825203742145'"><img class="workIcon" src="@/assets/images/smartup.jpg" />{{ app.appName }}</strong>
                  <strong v-else-if="app.appCode === 'APPS20220610115258429'"><img class="workIcon" src="@/assets/images/alimcall.jpg" />{{ app.appName }}</strong>
                  <strong v-else-if="app.appCode === 'APPS20220103175140644'"><img class="workIcon" src="@/assets/images/frientsIo.png" />{{ app.appName }}</strong>
                  <strong v-else-if="app.appCode === 'APPS20220701131556689'"><img class="workIcon" src="@/assets/images/wishpond.png" />{{ app.appName }}</strong>
                  <strong v-else><img class="workIcon" src="@/assets/noimage.png" />{{ app.appName }}</strong>
              </div>
            </div>

            <!-- 앱 선택 후 -->
            <div
              class="row clearfix"
              v-if="selectedApp != null"
            >
              <div >
                <div
                  class="header"
                  v-if="selectedApp != null"
                >
                  {{ choosedApp.appName }}
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div
                  class="panel-group"
                  id="accordion_1"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div class="panel panel-primary card">
                    <div class="panel-heading" role="tab" id="headingOne_1">
                      <h4 class="panel-title back-gray">
                        <a
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion_1"
                          href="#collapseOne_1"
                          aria-expanded="true"
                          aria-controls="collapseOne_1"
                          @click="show('CE', actionCount)"
                        >
                          앱 &amp; 이벤트 선택
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseOne_1"
                      class="panel-collapse collapse in"
                      role="tabpanel"
                      aria-labelledby="headingOne_1"
                      :class="{ show: showCE }"
                    >
                      <div class="panel-body">
                        <h2 class="card-inside-title">앱</h2>
                        <select
                          class="form-control show-tick"
                          v-model="selectedApp"
                          @change="chooseApp(actionCount)"
                        >
                          <option :value="''">-- 선택 --</option>
                          <option
                            v-for="(app, index) in totalAppList"
                            :key="index"
                            :value="app.appCode"

                          >
                            {{ app.appName }}
                          </option>
                        </select>
                        <h2 class="card-inside-title">
                          액션 이벤트

                        </h2>
                        <!--                          @click="getApiList(i)"-->
                        <select
                          class="form-control show-tick"
                          v-model="choosedApi"
                        >
                          <option value="" disabled>
                            -- 선택 --
                          </option>
                          <option
                            v-for="api in actionLists"
                            :key="api.apiCode"
                            :value="api.apiCode"
                          >
                            {{ api.apiName }} ( {{ api.versionCode }} )
                          </option>
                        </select>

                        <!-- 일단 주석 (삭제x)
                        <div class="help-info">
                          This is what starts the Zap.
                        </div> -->

                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-continue"
                          v-if="
                            workflowStore.workflowsS[actionCount].api.apiCode ==
                            '' || actionLists.length == 0
                          "
                          disabled
                        >
                          계속 진행하려면 앱을 선택해주세요.
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-continue"
                          v-if="
                            workflowStore.workflowsS[actionCount].api.apiCode !=
                            '' && actionLists.length != 0
                          "
                          @click="
                            show('CA', actionCount), getAuthLists(actionCount)
                          "
                        >
                          <!--                          getApiDetail(i),-->
                          계속 진행
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-primary card">
                    <div class="panel-heading" role="tab" id="headingTwo_1">
                      <h4 class="panel-title back-gray">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion_1"
                          href="#collapseTwo_1"
                          aria-expanded="false"
                          aria-controls="collapseTwo_1"
                          @click="show('CA', actionCount)"
                        >
                          계정선택
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseTwo_1"
                      class="panel-collapse collapse"
                      role="tabpanel"
                      aria-labelledby="headingTwo_1"
                      :class="{ show: showCA }"
                    >
                      <div class="panel-body">
                        <h2 class="card-inside-title">계정<small>추가 후 불러오기를 클릭해주세요</small></h2>
                        <div>
                          <button
                            type="button"
                            class="btn back-gray btn-continue"
                            style="float: right; margin-left: 5px"
                            @click="getAuthLists(actionCount)"
                          >
                            <font-awesome-icon
                              :icon="faRedo"
                              :class="{ 'fa-spin': reloadAuthBtn }"
                            />
                            <span style="font-size: 12px">불러오기</span>
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            class="btn back-gray btn-continue"
                            style="float: right"
                            @click="getAuth(actionCount)"
                          >
                            추가
                          </button>
                        </div>
                        <div>
                          <select
                            class="form-control show-tick"
                            v-model="selectAuth"
                            @change="selectingAuth(actionCount)"
                          >
                            <option :value="null">-- 선택 --</option>
                            <option
                              v-for="(auth, index) in testAuthList"
                              :key="index"
                              :value="auth.connectionCode"
                            >
                              # {{ index + 1 }}번 (생성일 :
                              {{ auth.insertDt }})
                            </option>
                          </select>
                        </div>

                        <!-- <select
                          class="form-control show-tick"
                          v-model="selecAcc"
                        >
                          <option value="" disabled selected>
                            계정을 선택해 주세요
                          </option>
                          <option
                            v-for="tAccount in tAccounts"
                            :key="tAccount.id"
                            :value="tAccount.tAccount"
                            @click="showModal('auth', 'open')"
                          >
                            {{ tAccount.tAccount }}
                          </option>
                        </select> -->

                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-continue"
                          v-if="selectAuth == null"
                          disabled
                        >
                          계속 진행하려면 계정을 선택해주세요.
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-continue"
                          v-if="selectAuth != null"
                          @click="setActInputs(actionCount), updateWorkflow()"
                        >
                          계속 진행
                        </button>
<!--                        <button-->
<!--                          type="button"-->
<!--                          class="btn btn-primary btn-block btn-continue"-->
<!--                          v-if="selectAuth != null && authForms.length <= 0"-->
<!--                          @click="show('TT'), updateWorkflow()"-->
<!--                        >-->
<!--                          계속 진행-->
<!--                        </button>-->
                      </div>
                    </div>
                  </div>
                  <div
                    class="panel panel-primary card"
                    v-show="apiSettingList.length > 0"
                  >
                    <div class="panel-heading" role="tab" id="headingThree_1">
                      <h4 class="panel-title back-gray">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion_1"
                          href="#collapseThree_1"
                          aria-expanded="false"
                          aria-controls="collapseThree_1"
                          @click="show('SA', actionCount)"
                        >
                          액션 설정
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseThree_1"
                      class="panel-collapse collapse"
                      role="tabpanel"
                      aria-labelledby="headingThree_1"
                      :class="{ show: showSA }"
                    >
                      <div class="panel-body">
                        <div
                          v-for="(form, index) in apiSettingList"
                          :key="index"
                        >

                          <div v-if="form.dropdown == 0 || form.dropdown == undefined">
                            <h2 class="card-inside-title">{{apiSettingList[index].label }} ({{apiSettingList[index].key }})<small>{{ optionalOrNot(form.required) }}</small></h2>
                            <div v-if="form.multi == 0">
                              <user-editor-test-box  v-bind:actionCount="actionCount" v-bind:multiFormIndex="index"/>
                              <input
                                type="text"
                                class="form-control"
                                :placeholder="form.label"
                                :name="form.key"
                                v-model="apiSettingList[index].value"
                                @input="addWorkflowValue(null, actionCount, index)"
                              />

                              <input
                                  type="text"
                                  class="form-control"
                                  :placeholder="form.label"
                                  :name="form.key"
                                  v-model="workflowStore.workflowsS[actionCount].api.design.forms[index].value"
                                  hidden
                              />




                            </div>
<!--                            {{form.multi}}-->
                            <div v-if="form.multi == 1">


<!--                              {{apiSettingList[index].multibox}}-->

                              <user-editor-multi-boxs v-bind:actionCount="actionCount" v-bind:multiFormIndex="index" />
                            </div>

                          </div>
                          <div v-if="form.dropdown == 1">
                            <div v-if="form.dropdownSource.type == 'static'">
                              <user-editor-dropdown-type v-bind:formData="form" v-bind:actionCount="actionCount" v-bind:dropdownIndex="index" />
                            </div>
                            <div v-if="form.dropdownSource.type == 'dynamic'">
                              <user-editor-dropdown-source v-bind:indexs="index" v-bind:actionCount="actionCount" v-bind:authCount="selectAuth" v-bind:dropdownSource="apiSettingList[index]"/>
                            </div>
                          </div>

                          <div v-if="form.checkType == 'lineGroup'">
<!--                            rmfnq-->
<!--                            {{form}}-->
                            <div v-for=" (vval , inin) in form.form"  v-bind:key="inin">

<!--{{vval}}-->
                              <span>{{vval.label}} ({{vval.key}})</span>
                              <input
                                  type="text"
                                  class="form-control"
                                  :placeholder="vval.key"
                                  v-model="workflowStore.workflowsS[actionCount].api.design.forms[index].form[inin].value"
                                  style="margin: 5px"
                              />

                            </div>


<!--                            <input-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="first_name"-->
<!--                              name="firstName"-->
<!--                              style="margin: 5px"-->
<!--                            />-->
<!--                            <input-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="last_name"-->
<!--                              name="lastName"-->
<!--                              style="margin: 5px"-->
<!--                            />-->
                            <div >

<!--                              <user-editor-dropdown-source v-bind:indexs="index" v-bind:actionCount="actionCount" v-bind:authCount="selectAuth" v-bind:dropdownSource="apiSettingList[index]"/>-->
                            </div>

                          </div>

                        </div>
                        <button
                          type="button"
                          class="btn btn-primary btn-block btn-continue"
                          @click="checkIfNull()"
                        >
                          계속 진행
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-primary card">
                    <div class="panel-heading" role="tab" id="headingFour_1">
                      <h4 class="panel-title back-gray">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-parent="#accordion_1"
                          href="#collapseThree_1"
                          aria-expanded="false"
                          aria-controls="collapseThree_1"
                          @click="show('TA', actionCount)"
                        >
                          액션 테스트
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseThree_1"
                      class="panel-collapse collapse"
                      role="tabpanel"
                      aria-labelledby="headingThree_1"
                      :class="{ show: showTA }"
                    >
                      <div class="panel-body">
                        <div style="text-align: center">
                          계정연결과 액션 설정이 정상적으로 되어있는지
                          확인합니다.
                        </div>
                        <div>
                          <div v-if="testResult.length > 0">
                            <div class="form-group">
                              <div class="form-line">
<!--                                <div v-if="showArrayText">Array 타입이 아닙니다.</div>-->
                                <textarea
                                  rows="10"
                                  class="form-control no-resize"
                                  v-model="testResult"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="text-align: center">
                          <button
                            type="button"
                            class="btn btn-primary btn-continue"
                            :disabled="testResult != ''"
                            @click="actionTest()"
                          >
                            테스트하기
                          </button>
                          &nbsp; &nbsp;
                          <button
                            type="button"
                            class="btn btn-primary btn-continue"
                            @click="saveAction()"
                          >
                            저장하기
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ul>
    </div>
    <div
      class="col-md-12 col-lg-12 center"
      v-if="actionCount == workflowStore.workflowsS.length - 1"
    >
      <button class="btn btn-default workBtn" @click="addAction()">+</button>
    </div>
  </div>
  </div>
</template>

<script>
import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import eventbus from "@/store/modules/devEventBus";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import UserEditorMultiBoxs from "@/views/user/editor/UserEditorMultiBoxs";
import UserEditorDropdownType from "@/views/user/editor/UserEditorDropdownType";
// import Index from "@/assets/plugins/ckeditor/samples/toolbarconfigurator/index.html";
// import Index from "@/assets/plugins/ckeditor/samples/toolbarconfigurator/index.html";
import UserEditorTestBox from "@/views/user/editor/UserEditorTestBox";
import UserEditorDropdownSource from "@/views/user/editor/UserEditorDropdownSource";

export default {
  name: "UserEditorAction",
  props: ["actionCount"],
  components: {
    UserEditorDropdownType,
    UserEditorMultiBoxs,
    UserEditorTestBox,
    UserEditorDropdownSource,
    // Index,
    // Index,
    FontAwesomeIcon,
  },
  data() {
    return {
      selectedApp: null,
      totalAppList: [],
      keyword: "",

      actionLists: [],
      selectAuth: null,
      testAuthList: null,
      authForms: [],
      apiSettingList: [],
      choosedApi : '',
      tagVal: [],


      actionJson : {},


      appName: "",
      selecEvent: "",
      selecAcc: "",
      selecAct: "",
      showCE: true,
      showCA: false,
      showSA: false,
      showTA: false,
      actionNum: "",
      actionCode: 0,
      choosedApp: [],
      tAccounts: [
        {
          id: "1",
          tAccount: "ss@gmail.com",
        },
      ],
      forms: [],
      appNames: [],
      appCode: "",
      formIndex: 0,
      apiDetail: [],

      faSearch,
      faRedo,
      reloadAuthBtn: false,
      testResult: "",
      showArrayText : false,

    };
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
    getWorkflowAction() {
      return this.$store.getters.getWorkflowActions;
    },
  },
  watch : {
    getWorkflowAction(workflows){
      console.log("이거ㅓ어어",workflows)

      console.log(this.actionCount)






      if (this.$store.state.workflowStore.workflowsS[this.actionCount].api.appCode != "") {
        // this.choosedApp =
        //   this.$store.state.workflowStore.workflowsS[
        //     this.actionCount
        //   ].api.appCode;
        // this.$store.state.workflowStore.workflow.workflowCode = this.$store.state.workflowStore.workflowCode

        this.choosedApp =
            this.$store.state.workflowStore.workflowsS[this.actionCount].api;
        this.selectedApp = this.choosedApp.appCode
        this.getApiList(this.actionCount);

        // choosedApp

        this.choosedApi =
            this.$store.state.workflowStore.workflowsS[
                this.actionCount
                ].api.apiCode;
        this.showCA = true;

        //계정 연결
        this.getAuthLists(this.actionCount);

        console.log(
            "폼 :",
            this.$store.state.workflowStore.workflowsS[this.actionCount].api.design
                .forms.length
        );

        if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design
            .forms != undefined){

          if (
              this.$store.state.workflowStore.workflowsS[this.actionCount].api.design
                  .forms.length > 0
          ) {
            this.showSA = true;

            var valueFor = "";
            var sublist = [];
            for (var m = 0; m < this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms.length; m++) {


              console.log("ddkdkdkdkdkd:",this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value)

              if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value.indexOf("[{")>-1){
                var valval = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value
                var start = valval.indexOf("[{")
                var end = valval.indexOf("}]")

                var valvalStart = valval.substr(0, start)
                var valvalEnd = valval.substr(end+2, valval.length)
                valueFor = valvalStart + valvalEnd



              } else {
                valueFor = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value
              }

              if(valueFor == undefined || valueFor == 'undefined'){
                valueFor = ""
              }

              var formVal = "";
              if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].form != null){
                formVal = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].form
              }

              sublist.push({
                key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].keys,
                label: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].label,
                dropdown: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dropdown,
                multi: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].multi,
                required: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].required,
                dynamic: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dynamic,
                dropdownSource: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dropdownSource,
                form: formVal,
                value: valueFor,
                multibox: ""
              });
            }

            this.apiSettingList = sublist;

            console.log("폼 :", this.apiSettingList);
          }



        }


        this.showTA = true;
      }






    }


  },

  methods: {
    checkIfNull(){


      var workflowForm = this.$store.state.workflowStore.workflowsS
      var forms = workflowForm[this.actionCount].api.design.forms

      for(var i = 0; i < forms.length; i++){
        console.log("ㅇㅇㅇㅇ---", forms[i].value, forms[i].required)

        if(forms[i].required == 1 ){
          if(forms[i].value == "" || forms[i].value == undefined){
            alert("필수 사항을 입력해주세요.")
            return;

          }
        }



      }


      this.showArrayText = false;



      this.show('TA')
      this.updateWorkflow()
    },
    selectApp(name) {
      this.appName = name;
    },
    optionalOrNot(val){
      if(val == 0){
        return "선택"
      } else {
        return "필수"
      }
    },
    show(step, i) {
      this.testResult = ""

      if (step == "CE") {
        this.showCE = !this.showCE;
      }
      if (step == "CA") {
        if (this.workflowStore.workflowsS[i].api.apiCode == "") {
          this.showCA = false;
        } else {
          this.showCA = true;
          this.showSA = false;
          this.showTa = false;
        }
      }

      if (step == "SA"  && this.choosedApp != null ) {

        this.showSA = !this.showSA;
      }
      if (step == "TA" && this.choosedApp != null) {
        this.showTA = !this.showTA;
      }
    },
    addAction() {

      // workflows에 action추가
      const workflows = this.workflowStore.workflowsS;
      const index = workflows.length + 1;

      const obj = { type: "action", index: index - 1 };
      obj.authentication = JSON.parse(
        JSON.stringify(this.workflowStore.authenticationS)
      );
      obj.api = JSON.parse(JSON.stringify(this.workflowStore.apiS));

      workflows.push(obj);
      this.$store.dispatch("buildWorkflows", workflows);

      // names에 빈객체 추가
      // const names = this.workflowStore.appNames;
      // names.push(JSON.parse(JSON.stringify({ code: "", name: "" })));
      // this.$store.dispatch("buildAppNames", names);

      this.$store.dispatch("saveWorkflowForm", workflows);
      this.updateWorkflow();



      this.$emit("addedNewAction");
    },
    showForm(i) {
      if (this.formIndex == i) {
        this.formIndex = 0;
      } else {
        this.formIndex = i;
      }
    },
    // getAppList() {
    //   var param = { userCode: this.userStore.userCode };
    //   this.$store.dispatch("getAppList", {
    //     paths: Apiroot.app + Urls.appList,
    //     params: param,
    //   });
    // },
    // getAppDetail(code) {
    //   var param = { appCode: code };
    //   this.$store.dispatch("getAppDetail", {
    //     paths: Apiroot.userApp + Urls.getAppDetail,
    //     params: param,
    //   });
    // },
    async getApiList(i) {
      var app = this.choosedApp;

      var param = { appCode: app.appCode, versionCode: app.versionCode };

      this.api.selectApi(param).then((res) => {
        console.log("결과1", res, i);

        // this.apiList = res.api
        var list = [];
        // var subList = []

        for (var j = 0; j < res.api.length; j++) {
          if (res.api[j].apiType == "action") {
            var vvvv = JSON.parse(res.api[j].apiSchema).visible


            if(vvvv == 'Y' ){
              list.push(res.api[j]);

            }
            // subList.push({key:res.api[j].apiKey, label:res.api[j].apiName, value:""})
          }
        }

        console.log("결과2", list);

        this.actionLists = list;

        if(this.apiSettingList.length == 0) {
          this.setActInputs(this.actionCount)
        }


      });
    },
    async getAuth(i) {
      const code = this.workflowStore.workflowsS[i].api.appCode;
      const ver = this.workflowStore.workflowsS[i].api.versionCode;

      console.log(code, ver);

      var param = { appCode: code, versionCode: ver };

      this.api.getApiList(param).then((res) => {
        console.log("get:", res, i);

        for (var j = 0; j < res.apis.length; j++) {
          console.log(res.apis[j]);

          if (res.apis[j].apiType == "authentication") {
            this.$store.state.devStore.apiAuth[0] = res.apis[j];
            this.$store.state.devStore.apiData = res.apis[j];
          }
        }


        this.api.selectOneApi({apiCode : this.$store.state.devStore.apiData.apiCode})
            .then((res)=>{

              console.log("모달 띄우기 전 :",res)

              var formform = [];

              var today = new Date();
              var year = today.getFullYear();
              var month = ("0" + (1 + today.getMonth())).slice(-2);
              var day = ("0" + today.getDate()).slice(-2);

              var insertDt =  year + "-" + month + "-" + day;

              for(var i = 0;  i < JSON.parse(res.api.apiSchema).design.forms.length; i++){
                var list = new Object;



                list = {
                  key: JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(
                      /"/gi,
                      ""
                  ),
                  label: "{{bundle.authData." + JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(/"/gi, "") + "}}",
                  value: "",
                  insertDt: insertDt,
                  index: i + 1,
                };


                formform.push(list);








              }


              console.log("모달 띄우기 전:", formform)


              this.$store.state.workflowStore.modalInput = formform;




            })





















        this.$store.dispatch("setAuthModal", {
          params : i,
          status : true

        });

        // eventbus.$emit("openAuthModal", i);
      });


      // eventbus.$emit("openAuthModal", i);

      // const res = await this.$store.dispatch("getApiList", {
      //   paths: Apiroot.userApi + Urls.getApiList,
      //   params: param,
      // });
      //
      // const workflows = this.workflowStore.workflowsS;
      // workflows[i].api.test = {};
      // workflows[i].api.test = JSON.parse(
      //   JSON.stringify(this.workflowStore.testS)
      // );
      //
      // const forms = JSON.parse(res.auths[0].apiSchema).design.forms;
      // forms.workflowIndex = i;
      // for (var j = 0; j < forms.length; j++) {
      //   workflows[i].api.test.request.params.push({
      //     name: forms[j].label,
      //     value: "",
      //   });
      // }
      //
      // const modalParam = {
      //   workflowIndex: i,
      //   forms: forms,
      //   apiSchema: JSON.parse(res.auths[0].apiSchema),
      // };
      //
      // this.showModal("auth", "open", modalParam);
    },
    // async getAllApiList() {
    //   var param = {};
    //   await this.$store.dispatch("getAllApiList", {
    //     paths: Apiroot.userApi + Urls.getAllApiList,
    //     params: param,
    //   });
    // },
    resetData() {
      this.authForms = [];
      this.selectApi = null;
      this.apiSettingList = [];
      this.selectAuth = null;
      this.testAuthList = null;
      this.testResult = "";

      this.showCA = false;
      this.showSA = false;
      this.showTA = false;
    },
    chooseApp(i, index) {

      this.resetData();

      this.actionLists = [];
      // var workflowForm = this.$store.state.workflowStore.workflowsS;

      if (index != null) {

        this.choosedApp = this.totalAppList[index];
        this.selectedApp = this.totalAppList[index].appCode;
        const workflows = this.workflowStore.workflowsS;
        workflows[i].api = this.choosedApp;
      } else {

        console.log("value is null : ", this.choosedApp.appCode)

        var code = this.selectedApp;


        console.log("select app:", this.choosedApp);

        for (var q = 0; q < this.totalAppList.length; q++) {

          if (this.totalAppList[q].appCode == code) {
            console.log(this.totalAppList[q]);
            const workflows = this.workflowStore.workflowsS;
            workflows[this.actionCount].api = this.totalAppList[q];

            this.choosedApp = this.totalAppList[q];
            // this.selectedApp = this.totalAppList[q].appCode;

          }
        }
      }
      // this.$store.dispatch("buildWorkflows", workflows);

      // this.$store.dispatch("saveWorkflowForm", workflowForm);
      // this.updateWorkflow()

      // api리스트 불러오기
      this.getApiList(i);
    },
    async updateWorkflow() {

      var workflowString = JSON.stringify(this.$store.state.workflowStore.workflowsS)
      workflowString = workflowString.replaceAll("undefined", "");

      var param = {
        workflowCode: this.$store.state.workflowStore.workflowCode,
        workflowName: this.$store.state.workflowStore.workflowName,
        groupCode: this.$store.state.workflowStore.groupCode,
        insertDt: "",
        workflows: workflowString,
      };

      console.log(param);
      console.log(this.$store.state.workflowStore.workflowsS);

      this.api.updateWorkflow(param).then((res) => {
        if (this.utils.preApiHandle(res)) {
          console.log("updateWorkflow res : ", res);
        }

        if (res.code == 0) {
          console.log("action 저장 완료");
          return res;
        }

      });
    },
    changeApp(i) {
      const code = this.workflowStore.workflowsS[i].api.appCode;
      const apps = this.workflowStore.apps;

      for (var j = 0; j < apps.length; j++) {
        if (apps[j].appCode == code) {
          this.choosedApp = apps[j];
        }
      }

      var param2 = { index: i };
      this.$store.dispatch("resetState", { params: param2, tag: "changeApp" });

      this.getApiList(i);
    },

    getSourceTriggerApi(code) {
      var param = { apiCode: code };
      this.$store.dispatch("getSourceTriggerApi", {
        paths: Apiroot.userApi + Urls.getApiDetail,
        params: param,
      });
    },
    showModal(tag, status, param) {
      this.$store.dispatch("showModal", {
        params: param,
        tag: tag,
        status: status,
      });

      document.getElementsByClassName("overlay")[0].style.display = "block";
    },

    totalApps() {
      // this.$store.state.workflowStore.workflowsS[i].api = []

      var param = {
        userCode: this.$store.state.userStore.userCode,
        keyword: this.keyword,
      };

      this.api.appWorkflowList(param).then((res) => {
        console.log("total apps :", res);

        this.totalAppList = res.app;
      });
    },

    getImagePath(value) {
      if (value != undefined) {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },

    getAuthLists(i) {


      this.$store.state.workflowStore.workflowsS[this.actionCount].api.apiCode =  this.choosedApi

      //저장을 한 후 -- 불러오기가 안됨 그것만 추가하면 될듯



      this.reloadAuthBtn = true;

      console.log("api auth ", i);

      var list = [];

      var param = {
        userCode : this.$store.state.userStore.userCode,
        appCode : this.$store.state.workflowStore.workflowsS[this.actionCount].api.appCode,
        versionCode : this.$store.state.workflowStore.workflowsS[this.actionCount].api.versionCode
      };

      console.log(param);

      this.api.getConnectionList(param)
      .then((res) => {
        console.log(res);

        const connections = res.connections;
        console.log("connections : ", connections);

        if (connections != null) {
          for (var i = 0; i < connections.length; i++) {
            // console.log(api[i]);
          //   if (api[i].apiType != "trigger" && api[i].apiType != "action") {
          //     console.log(
          //       "인증:",
          //       JSON.parse(api[i].apiSchema).test.request.authentication
          //     );
          //     console.log(JSON.parse(api[i].apiSchema).design.forms);
          //     this.authForms.push(JSON.parse(api[i].apiSchema).design.forms);
          //
          //     list.push(
          //       JSON.parse(api[i].apiSchema).test.request.authentication
          //     );
          //   }
          // }
            list.push({
              connectionCode : connections[i].connectionCode,
              apiKey : connections[i].apiKey,
              connectionName : connections[i].connectionName,
              insertDt : connections[i].insertDt,
              workflowCode : connections[i].workflowCode
            });

            if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication.connectionCode != null){
              if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication.connectionCode == connections[i].connectionCode){
                this.selectAuth = connections[i].connectionCode
              }
              // this.saveAuth(list);
            }



        }}
        console.log("list:", list);

        this.testAuthList = list;

        // if (
        //   this.$store.state.workflowStore.workflowsS[this.actionCount]
        //     .authentication.index != undefined
        // ) {
        //   this.saveAuth(list);
        // }

        this.reloadAuthBtn = false;
      });
    },

    saveAuth(list) {
      console.log(
        this.$store.state.workflowStore.workflowsS[this.actionCount]
          .authentication.content
      );
      for (var i = 0; i < list.length; i++) {
        // if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication.content[i][0].value == list[i][0].value){
        //   console.log("아! ")
        // }
        //값을 다 비교해서 모두 같으면 해당걸로 선택 하기
        console.log("ddd", list[i].length);
        console.log(
          "vvv",
          this.$store.state.workflowStore.workflowsS[this.actionCount]
            .authentication
        );

        for (var j = 0; j < list[i].length; j++) {
          console.log(list[i][j]);

          if (
            JSON.stringify(Object.values(list[i][j])) ==
            JSON.stringify(
              Object.values(
                this.$store.state.workflowStore.workflowsS[this.actionCount]
                  .authentication.content[j]
              )
            )
          ) {
            this.selectAuth = i;
          }

          console.log(Object.values(list[i][j]));
          //
          console.log(
            Object.values(
              this.$store.state.workflowStore.workflowsS[this.actionCount]
                .authentication.content[j]
            )
          );
          //   if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication[0][j] == list[i][j]){
          //     console.log("ddddd")
          //   }
        }
      }
    },
    setActInputs(index) {
      console.log("ㅇㅇㅇ");
      console.log(index);

      var workflowForm = this.$store.state.workflowStore.workflowsS;
      var sublist = [];

      for (var i = 0; i < this.actionLists.length; i++) {
        console.log(this.actionLists[i].apiCode);
        if (this.actionLists[i].apiCode == this.choosedApi) {
          console.log(
            "json :",
            JSON.parse(this.actionLists[i].apiSchema).design.forms
          );

          this.apiDetail = this.actionLists[i];

          workflowForm[index].api.apiCode = this.apiDetail.apiCode;
          workflowForm[index].api.apiName = this.apiDetail.apiName;
          workflowForm[index].api.apiKey = this.apiDetail.apiKey;
          workflowForm[index].api.apiType = this.apiDetail.apiType;
          workflowForm[index].api.versionCode = this.apiDetail.versionCode;

          workflowForm[index].api.design = JSON.parse(
            this.apiDetail.apiSchema
          ).design;
          workflowForm[index].api.configure = JSON.parse(
            this.apiDetail.apiSchema
          ).configure;
          workflowForm[index].api.test = JSON.parse(
            this.apiDetail.apiSchema
          ).test;
          workflowForm[index].api.define = JSON.parse(
            this.apiDetail.apiSchema
          ).define;

          if (
            JSON.parse(this.actionLists[i].apiSchema).design.forms != undefined
          ) {
            for (
              var j = 0;
              j < JSON.parse(this.actionLists[i].apiSchema).design.forms.length;
              j++
            ) {


              var formVal = "";
              if(JSON.parse(this.actionLists[i].apiSchema).design.forms[j].form != null && JSON.parse(this.actionLists[i].apiSchema).design.forms[j].form != undefined){
                formVal = JSON.parse(this.actionLists[i].apiSchema).design.forms[j].form
              }

              console.log("ㅇㅇ:::",  workflowForm[index].api.design.forms[j])




              sublist.push({
                key: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].keys,
                label: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].label,
                checkType: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].checkType,
                dropdown: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].dropdown,
                multi: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].multi,
                required: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].required,
                dynamic: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].dynamic,
                dropdownSource: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].dropdownSource,
                value: JSON.parse(this.actionLists[i].apiSchema).design.forms[j].value,
                form: formVal,
                multibox: ""
              });
            }
          }
        }
      }

      console.log("sublist:", sublist);
      this.apiSettingList = sublist;

      if(this.apiSettingList.length > 0){
        this.show('SA')
      } else {
        this.show('TT')
      }

      //  dropdownSource \ 으로 표시되는 내용 수정해서 다시 담는 부분
      for (var ss = 0; ss < workflowForm[index].api.design.forms.length; ss++) {
        if (
          workflowForm[index].api.design.forms[ss].dropdown == 1 &&
          workflowForm[index].api.design.forms[ss].dropdownSource.codeSource !=
            undefined
        ) {
          workflowForm[index].api.design.forms[ss].dropdownSource.codeSource =
            JSON.parse(
              workflowForm[index].api.design.forms[ss].dropdownSource.codeSource
            );
        }
      }

      this.$store.dispatch("saveWorkflowForm", workflowForm);
      //     .then(()=>{
      //         this.updateWorkflow()
      //
      // })
    },

    // setActionJson(){
    //   this.actionJson.push("",)
    //
    // }

    async saveAction() {
      this.updateWorkflow();




    },
    async actionTest() {

      if (this.choosedApp.appCode != "APPS20220308170107323") {

        var param = {
          appCode: this.choosedApp.appCode,
          apiCode: this.selectApi,
          versionCode: this.choosedApp.versionCode,
          // paramData: JSON.stringify(this.testAuthList[this.selectAuth]),
          // authIndex: this.selectAuth,
          workflowCode: this.$store.state.workflowStore.workflowCode,
          workIndex: this.actionCount,
          testData: JSON.stringify(this.$store.state.userStore.testData)
        };

        console.log(param);
        console.log(this.choosedApp);
        // console.log(this.testAuthList[4])

        this.api.workflowApi(param).then((res) => {
          console.log("connectApi res : ", res);

          //array 마지막 1개만 출력해서 store. testData 쪽에 넣어두기
          if (typeof JSON.parse(res.result) === "object") {
            var datas = JSON.parse(res.result);

            if(!Array.isArray(datas)){

              var bigKey = Object.keys(datas);
              console.log("big key:", bigKey)
              console.log("big key:", datas)
              for(var i = 0; i < bigKey.length; i++){
                var subDatas = datas[bigKey[i]]
                if(Array.isArray(subDatas)){

                  console.log(subDatas)
                  datas = subDatas
                  break;
                }

              }


            }


            if (Array.isArray(datas)) {
              this.showArrayText = false
              // datas = JSON.stringify(datas, null, 4)
              console.log("길이 :", datas);

              this.testResult = JSON.stringify(datas[datas.length - 1], null, 4);

              // 액션의 테스트 데이터 아직 오류가 조금 있어서 임시로 주석 해놓음
              // if(datas.length > 0){
              //   console.log(this.$store.state.userStore.testData.length, '====',this.actionCount)
              //
              //   if(this.$store.state.userStore.testData.length == this.actionCount + 1){
              //     this.$store.state.userStore.testData[this.actionCount] = {
              //       key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.apiName,
              //       value: datas[datas.length - 1],
              //     };
              //
              //   } else if(this.$store.state.userStore.testData.length > this.actionCount + 1){
              //     this.$store.state.userStore.testData.push({
              //       key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.apiName,
              //       value: datas[datas.length - 1],
              //     });
              //
              //   }
              //
              // } else {
              //
              //   if(this.$store.state.userStore.testData.length == this.actionCount + 1){
              //     this.$store.state.userStore.testData[this.actionCount] = {
              //       key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.apiName,
              //       value: this.$store.state.workflowStore.workflowsS[this.actionCount].api.define.source,
              //     };
              //
              //   } else if(this.$store.state.userStore.testData.length > this.actionCount + 1){
              //     this.$store.state.userStore.testData.push({
              //       key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.apiName,
              //       value: this.$store.state.workflowStore.workflowsS[this.actionCount].api.define.source,
              //     });
              //
              //   }
              //
              // }


            } else {
              this.testResult = JSON.stringify(datas, null, 4)
              this.showArrayText = true

              // this.testResult = "Array 타입이 아닙니다. " ;
            }
          }

          this.saveAction()

          // this.testResult = JSON.stringify(JSON.parse(res.result), null, 4);
        });

      } else {
        console.log("ddd not ")


        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("X-Api-Token", "074a4504a82a07a651705c476a825d3d");


        var workflowDesign = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms
        var workflowConfig = this.$store.state.workflowStore.workflowsS[this.actionCount].api.configure

        var bodyData = new Map();

        if (workflowDesign != null) {
          for (var i = 0; i < workflowDesign.length; i++) {
            console.log(workflowDesign[i])
            if (workflowDesign[i].checkType == "lineGroup") {

              // bodyData.keys
              var map = new Map();


              for (var j = 0; j < workflowDesign[i].form.length; j++) {


                map.set(workflowDesign[i].form[j].key, workflowDesign[i].form[j].value)


              }

              bodyData.set(workflowDesign[i].keys, map);
              console.log(bodyData)


            }
          }
        }


        // var meeme = workflowConfig.method.replace(/"/gi, "");

        var options = {}
        var url = ""

        var data = "";

        console.log(this.choosedApi)

        if(this.choosedApi == "APIS20220316105801064"){
          console.log(this.choosedApi)
          console.log(workflowDesign)
          //리드 조회
          options = {
            method : "GET",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[1].value}
          }

          url = workflowConfig.url + workflowDesign[0].value


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)


        } else if(this.choosedApi == "APIS20220308170501133"){

          //리드 생성
          options = {
            method : "POST",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[1].value},
            body : JSON.stringify(Object.fromEntries(bodyData))
          }

          url = workflowConfig.url;


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)


        } else if(this.choosedApi == "APIS20220317141214791"){
          //방문자 조회
          options = {
            method : "GET",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[0].value}
          }

          url = workflowConfig.url;


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)



        } else if(this.choosedApi == "APIS20220317141628927"){
          //방문자 개별

          options = {
            method : "GET",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[0].value}
          }

          url = workflowConfig.url + workflowDesign[1].value


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)

        } else if(this.choosedApi == "APIS20220317142409164"){
          //리스트 조회

          options = {
            method : "GET",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[0].value}
          }

          url = workflowConfig.url


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)

        } else if(this.choosedApi == "APIS20220317142703237"){
          //리스트 개별 조회

          options = {
            method : "GET",
            headers : {"Content-Type": "application/json", "X-Api-Token": workflowDesign[0].value}
          }

          url = workflowConfig.url + workflowDesign[1].value


          const request = await fetch(url, options);

          console.log(request)

          // const res = await fetch(request);
          data = await request.json();
          console.log("결과 :", data)
        }



        this.testResult = JSON.stringify(data, null, 4)
        this.showArrayText = true


        // const request = new Request(workflowConfig.url.replace(/"/gi, ""),
        //     {
        //       method: meeme,
        //       headers,
        //       mode: "cors",
        //       cache: "default",
        //       body: Object.fromEntries(bodyData)
        //
        //     })






      }


    },

    selectingAuth(i) {
      var workflowForm = this.$store.state.workflowStore.workflowsS;
      workflowForm[i].authentication.connectionCode = this.selectAuth;
      // workflowForm[i].authentication.content =
      //   this.testAuthList[this.selectAuth];

      // this.$store.dispatch("saveWorkflowForm", workflowForm);
      // this.updateWorkflow();
    },

    removeAction(i) {
      if (confirm("삭제 하시겠습니까?")) {
        this.$emit("emitRemoveAction", i);
      }


    },
    addWorkflowValue(value, one, two){
      console.log(value, one, two)
      console.log("dsfsdds", this.apiSettingList[two].value)
      console.log("dsfsdds", this.$store.state.workflowStore.workflowsS[one].api.design.forms[two])


      //테스트에서 추가하는 경우
      if(value != null){

        if(value.length > 0){
          this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value =  JSON.stringify(value) + this.apiSettingList[two].value

        } else {

          this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value =  this.apiSettingList[two].value
        }




      } else {

        console.log(this.apiSettingList[two].value)

        //[{ 추가 되어있는 경우...에 대한 예외 ... 필요

        if(this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value != undefined && this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.indexOf("[{") > -1){
          var start = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.indexOf("[{")
          var end = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.indexOf("}]")

          console.log(start, end)

          console.log("마무리",this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.substr(start, end+2))

          // var firstMiddle = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.substr(0, start)
          // var secondMiddle = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.substr(end+2)
          var content = this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value.substr(start, end+2)

          // console.log(firstMiddle , secondMiddle)

          // var inputText = "";
          // if(this.apiSettingList[two].value != undefined){
          //   inputText = this.apiSettingList[two].value;
          // }


          this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value = content + this.apiSettingList[two].value;




        } else {

          if(this.apiSettingList[two].value != null && this.apiSettingList[two].value != undefined){
            this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value = this.apiSettingList[two].value

          } else {
            this.$store.state.workflowStore.workflowsS[one].api.design.forms[two].value = "";

          }



        }

      }

    }


  },
  created() {
    eventbus.$once("resetApiDetail" + this.actionCount, () => {
      this.getAuthLists(this.actionCount);
    });

    this.actionLists = [];
    this.apiSettingList = [];

    this.totalApps();

    //수정 시...workflowStore.workflowsS[actionCount].api.appCode
    console.log("start", this.$store.state.workflowStore.workflowCode);
    if (this.$store.state.workflowStore.workflowsS[this.actionCount].api.appCode != "") {
      // this.choosedApp =
      //   this.$store.state.workflowStore.workflowsS[
      //     this.actionCount
      //   ].api.appCode;
      // this.$store.state.workflowStore.workflow.workflowCode = this.$store.state.workflowStore.workflowCode

      this.choosedApp =
        this.$store.state.workflowStore.workflowsS[this.actionCount].api;
      this.selectedApp = this.choosedApp.appCode
      this.getApiList(this.actionCount);

      // choosedApp

      this.choosedApi =
        this.$store.state.workflowStore.workflowsS[
          this.actionCount
          ].api.apiCode;
      this.showCA = true;

      //계정 연결
      this.getAuthLists(this.actionCount);

      console.log(
        "폼 :",
        this.$store.state.workflowStore.workflowsS[this.actionCount].api.design
          .forms.length
      );

      if (
        this.$store.state.workflowStore.workflowsS[this.actionCount].api.design
          .forms.length > 0
      ) {
        this.showSA = true;
        // this.setTrigInputs();

        // this.apiSettingList = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms;


        // if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value != undefined){
        //   if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value.indexOf("[{")>-1){
        //     var valval = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value
        //     var start = valval.indexOf("[{")
        //     var end = valval.indexOf("}]")
        //
        //     var valvalStart = valval.substr(0, start)
        //     var valvalEnd = valval.substr(end+2, valval.length)
        //
        //     valueFor = valvalStart + valvalEnd
        //
        //   }
        //
        // }


        var valueFor = "";
        var sublist = [];
        for (var m = 0; m < this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms.length; m++) {


          if (this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value !== undefined && this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value != null) {
            if (this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value.indexOf("[{") > -1) {
              var valval = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value
              var start = valval.indexOf("[{")
              var end = valval.indexOf("}]")

              var valvalStart = valval.substr(0, start)
              var valvalEnd = valval.substr(end + 2, valval.length)
              valueFor = valvalStart + valvalEnd


            } else {
              valueFor = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].value
            }
          }

          // if(valueFor == undefined || valueFor == 'undefined'){
          //   valueFor = ""
          // }

          console.log(valueFor)

          var formVal = "";
          if(this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].form != null){
            formVal = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].form
          }

          // if(this.actionLists.length != 0) {
          //   this.setActInputs(this.actionCount)
          // }

          // this.setActInputs(this.actionCount)

          console.log("ㄹㄹㄹ::", formVal)


          //
          //
            sublist.push({
              key: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].keys,
              label: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].label,
              checkType: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].checkType,
              dropdown: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dropdown,
              multi: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].multi,
              required: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].required,
              dynamic: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dynamic,
              dropdownSource: this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[m].dropdownSource,
              form: formVal,
              value: valueFor,
              multibox: ""
            });
        }
        //
        this.apiSettingList = sublist


        console.log("폼 :", this.apiSettingList.length);
      }

      this.showTA = true;
    }

    // this.getAppList();
  },
};
</script>

<style scoped>
#UserEditorContent {
  padding: 40px;
  /* background: rgb(238, 238, 238); */
}
.appBtn {
  margin: 5px;
}
.btn-secondary {
  margin-top: 25px;
  margin-bottom: 30px;
}
.workBtn {
  margin: 5px;
}
</style>
